import { ApolloProvider } from "@apollo/client";
import { client } from "utils/apolloUploadClientLink";
import React from "react";
import { render } from "react-dom";

import Onboarding from "widgets/Onboarding";

import "./style.scss";
import configureOnboardingStore from "widgets/Onboarding/store/configureOnboardingStore";

configureOnboardingStore();
render(<ApolloProvider client={client}><Onboarding /></ApolloProvider>, document.getElementById("js-onboarding"));
